import React from 'react';
import styled from 'styled-components';

import Layout from '../../components/layout';
import SEO from '../../components/seo';
import BrandedCategory from '../../components/page-components/branded-category';

const BrandedCategoryPageContainer = styled.div``;

const BrandedCategoryPage = () => {
    return (
        <Layout>
            <SEO title="Branded Category" />
            <BrandedCategoryPageContainer>
                <BrandedCategory />
            </BrandedCategoryPageContainer>
        </Layout>
    );
};

export default BrandedCategoryPage;
